// const draggableVerticalDirective = {
//     mounted(el, binding) {
//         let { startFn, endFn } = binding.value;

//         let isDragging = false;
//         let startY = 0;
//         let currentY = 0;
//         let translateY = 0;
//         let animationFrame = null;

//         // 初始化触摸样式
//         Object.assign(el.style, {
//             position: 'absolute',
//             zIndex: 0,
//             userSelect: 'none',
//             touchAction: 'none', // 禁用默认触摸行为
//             willChange: 'transform'
//         });

//         const handleStart = e => {
//             if (e.touches.length !== 1) return;

//             isDragging = true;
//             const touch = e.touches[0];
//             startY = touch.clientY;
//             currentY = startY;

//             el.style.transition = 'none';
//             e.preventDefault();
//         };

//         const handleMove = e => {
//             if (!isDragging) return;
//             if (e.touches.length !== 1) return;

//             const touch = e.touches[0];
//             const deltaY = touch.clientY - startY;

//             // 更新位置
//             translateY = deltaY / 3;
//             applyTransform();

//             // 阻止滚动
//             e.preventDefault();
//             startFn();
//         };

//         const handleEnd = () => {
//             if (!isDragging) return;
//             isDragging = false;

//             // 平滑复位动画
//             resetPosition();
//             endFn();
//         };

//         const applyTransform = () => {
//             el.style.transform = `translate3d(0, ${translateY}px, 0)`;
//         };

//         const resetPosition = () => {
//             el.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
//             el.style.transform = 'translate3d(0, 0, 0)';

//             // 动画完成后清除过渡
//             setTimeout(() => {
//                 el.style.transition = '';
//             }, 300);
//         };

//         // 添加事件监听
//         el.addEventListener('touchstart', handleStart, { passive: false });
//         el.addEventListener('touchmove', handleMove, { passive: false });
//         el.addEventListener('touchend', handleEnd);
//         el.addEventListener('touchcancel', handleEnd);

//         // 清理函数
//         el._cleanup = () => {
//             el.removeEventListener('touchstart', handleStart);
//             el.removeEventListener('touchmove', handleMove);
//             el.removeEventListener('touchend', handleEnd);
//             el.removeEventListener('touchcancel', handleEnd);
//         };
//     },

//     unmounted(el) {
//         el._cleanup?.();
//         if (el._animationFrame) {
//             cancelAnimationFrame(el._animationFrame);
//         }
//     }
// };

// export default draggableVerticalDirective;

const draggableVerticalDirective = {
    mounted(el) {
        let isDragging = false;
        let startY = 0;
        let translateY = 0;
        let lastY = 0;
        let scrollElement = null;

        // 初始化样式
        // Object.assign(el.style, {
        //     position: 'fixed',
        //     width: '100%',
        //     touchAction: 'pan-y',
        //     userSelect: 'none',
        //     willChange: 'transform'
        // });

        // 查找第一个可滚动元素
        const findScrollElement = element => {
            while (element && element !== document.documentElement) {
                if (
                    element.scrollHeight > element.clientHeight &&
                    window.getComputedStyle(element).overflowY === 'auto'
                ) {
                    return element;
                }
                element = element.parentElement;
            }
            
            return null;
        };

        const handleStart = e => {
            if (e.touches.length !== 1) return;

            scrollElement = findScrollElement(e.target);
            startY = e.touches[0].clientY;
            lastY = startY;
            isDragging = true;

            el.style.transition = 'none';
        };

        const handleMove = e => {
            if (!isDragging || e.touches.length !== 1) return;

            const touch = e.touches[0];
            const deltaY = touch.clientY - lastY;
            lastY = touch.clientY;

            // 优先处理滚动
            if (scrollElement) {
                const isAtTop = scrollElement.scrollTop <= 0;
                const isAtBottom =
                    scrollElement.scrollTop + scrollElement.clientHeight >=
                    scrollElement.scrollHeight;

                // 判断滚动方向
                if (deltaY > 0 && isAtTop) {
                    // 向下滑动且已在顶部 - 触发拖拽
                    translateY += deltaY;
                    applyTransform();
                    e.preventDefault();
                } else if (deltaY < 0 && isAtBottom) {
                    // 向上滑动且已在底部 - 触发拖拽
                    translateY += deltaY;
                    applyTransform();
                    e.preventDefault();
                } else {
                    // 允许正常滚动
                    return;
                }
            } else {
                // 没有可滚动元素时直接拖拽
                translateY += deltaY;
                applyTransform();
                e.preventDefault();
            }
        };

        const handleEnd = () => {
            isDragging = false;
            resetPosition();
        };

        const applyTransform = () => {
            el.style.transform = `translate3d(0, ${translateY/3}px, 0)`;
        };

        const resetPosition = () => {
            el.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
            el.style.transform = 'translate3d(0, 0, 0)';

            setTimeout(() => {
                translateY = 0;
                el.style.transition = '';
            }, 300);
        };

        // 事件监听
        el.addEventListener('touchstart', handleStart, { passive: false });
        el.addEventListener('touchmove', handleMove, { passive: false });
        el.addEventListener('touchend', handleEnd);
        el.addEventListener('touchcancel', handleEnd);

        // 清理函数
        el._cleanup = () => {
            el.removeEventListener('touchstart', handleStart);
            el.removeEventListener('touchmove', handleMove);
            el.removeEventListener('touchend', handleEnd);
            el.removeEventListener('touchcancel', handleEnd);
        };
    },

    unmounted(el) {
        el._cleanup?.();
    }
};

export default draggableVerticalDirective;
